import * as React from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles/makeStyles';
import { Theme } from '@material-ui/core';
import { allLanguages, lang, LangType } from '../../Lang';
// @ts-ignore
import { ReactComponent as IconEN } from './icons/en.svg';
// @ts-ignore
import { ReactComponent as IconFI } from './icons/fi.svg';
// @ts-ignore
import { ReactComponent as IconSE } from './icons/sv.svg';
// @ts-ignore
import { ReactComponent as IconES } from './icons/es.svg';
// @ts-ignore
import { ReactComponent as IconVN } from './icons/vn.svg';
// @ts-ignore
import { ReactComponent as IconPT } from './icons/pt.svg';
import Button from '../../uicomponents/Button';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme: Theme) => createStyles({
  countryIcon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(1),
  },
  languageSelect: {
    padding: '8px 16px',
  },
}));

const flags: { locale: LangType, icon: any }[] = [
  { locale: 'en', icon: IconEN },
  { locale: 'es', icon: IconES },
  { locale: 'fi', icon: IconFI },
  { locale: 'vn', icon: IconVN },
  { locale: 'sv', icon: IconSE },
  { locale: 'pt', icon: IconPT },
];

type Props = {
  withText?: boolean;
  withFlag?: boolean;
};

const LanguageSelect = (props: Props) => {
  const { withText, withFlag } = props;
  const styles = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>  setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const onMenuClick = (item: { lang: LangType, label: string }) => () => {
    handleClose();
    if (item.lang !== lang.locale) {
      lang.change(item.lang);
    }
  };

  const createFlagIcon = (locale: string) => {
    const flag = flags.find(flag => flag.locale === locale);
    return flag ? React.createElement(flag.icon, { className: styles.countryIcon }) : null;
  };

  const icon = createFlagIcon(lang.locale);

  return (
    <>
      <Button
        className={styles.languageSelect}
        size={'small'}
        endIcon={<ArrowDropDown htmlColor={'#000'} />}
        onClick={handleClick}
      >
        {withFlag && icon} {withText && lang.label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {allLanguages.map(item => (
          <MenuItem
            dense
            key={item.lang}
            onClick={onMenuClick(item)}
            selected={item.lang === lang.locale}
          >
            <ListItemIcon style={{ minWidth: 36 }}>
              <>
                {createFlagIcon(item.lang)}
              </>
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

LanguageSelect.defaultProps = {
  withFlag: true,
};

export default LanguageSelect;
